import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import { Observable } from 'rxjs';
import { SalesSummary } from '../models/sales-summary';

@Injectable({
    providedIn: 'root'
})
export class SalesSummaryResource implements DataResource<SalesSummary> {
    private baseUrl: string;

    constructor(private http: HttpClient, private appSettings: AppSettings) {
        this.baseUrl = `${this.appSettings.apis.user}`;
    }

    get(): Observable<SalesSummary> {
        const url = `${this.baseUrl}/sales-summary`;
        return this.http.get<SalesSummary>(url);
    }
}
